// import permissionsList from 'app/permissions';
const permissionsList = {
	v_users_login: 1,
	v_users_logout: 2,
	v_posts_manage_post: 3,
	v_posts_edit_post: 4,
	v_posts_delete_post: 6,
	v_comments_send: 7,
	v_comments_approve: 8,
	v_admin_dashboard: 9,
	v_posts_publish_post: 10,
	v_posts_manage_movie: 11,
	v_posts_edit_movie: 12,
	v_posts_delete_movie: 13,
	v_posts_add_movie: 14,
	v_posts_manage_person: 15,
	v_posts_trash_post: 16,
	v_posts_trash_person: 17,
	v_posts_trash_movie: 18,
	v_posts_restore_post: 19,
	v_posts_restore_movie: 20,
	v_posts_move_post: 21,
	v_posts_register_person: 22,
	v_posts_edit_person: 23,
	v_posts_register_company: 24,
	v_posts_edit_company: 25,
	v_posts_manage_company: 26,
	v_posts_delete_person: 27,
	v_posts_delete_company: 28,
	v_posts_trash_company: 29,
};
const initialState = permissionsList;
const initList = initialState || [];
export default function permissions(state = initList, action) {
  return state;
}